import React from 'react'
import styled from 'styled-components'

interface Props {
    text: String
    icon: String
    onClick: any
    color?: string
}

export default function SpreedsheetOptions({text, icon, onClick, color = "#37A3EF", ...rest}:Props) {
    
    return (
        <Container color={color} onClick={onClick} {...rest}>
            <Icon color={color} className={`fa fa-${icon}`}/>
           <span>{text}</span>
        </Container>
    )
}

const Container = styled.div`
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: "row";
    cursor: pointer;

    span {
        font-family: 'Source Sans Pro', sans-serif; 
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;

        color:${props => props.color};
    }
`

const Icon = styled.i`
    font-family: Font Awesome 5 Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 40px;
    color: ${props => props.color};
    margin-right: 1rem;
`
